module.exports = __webpack_public_path__ + "media/images/black_google_play-734a3bad1b7f4947b7a27b7e3aa7d1cb.png";